/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuthTokenMetaUser } from './AuthTokenMetaUser';
import {
    AuthTokenMetaUserFromJSON,
    AuthTokenMetaUserFromJSONTyped,
    AuthTokenMetaUserToJSON,
    AuthTokenMetaUserToJSONTyped,
} from './AuthTokenMetaUser';

/**
 * 
 * @export
 * @interface AuthTokenMeta
 */
export interface AuthTokenMeta {
    /**
     * 
     * @type {string}
     * @memberof AuthTokenMeta
     */
    state: AuthTokenMetaStateEnum;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenMeta
     */
    type: AuthTokenMetaTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof AuthTokenMeta
     */
    expiresAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AuthTokenMeta
     */
    expiredReason: AuthTokenMetaExpiredReasonEnum;
    /**
     * 
     * @type {Date}
     * @memberof AuthTokenMeta
     */
    usedAt: Date | null;
    /**
     * 
     * @type {AuthTokenMetaUser}
     * @memberof AuthTokenMeta
     */
    user: AuthTokenMetaUser;
}

/**
* @export
* @enum {string}
*/
export enum AuthTokenMetaStateEnum {
    Expired = 'Expired',
    NonExistent = 'Non-existent',
    Used = 'Used',
    Valid = 'Valid'
}
/**
* @export
* @enum {string}
*/
export enum AuthTokenMetaTypeEnum {
    EmailRevert = 'Email Revert',
    EmailVerification = 'Email Verification',
    EmployeeConfirmation = 'Employee Confirmation',
    PhoneVerification = 'Phone Verification',
    SetPassword = 'Set Password'
}
/**
* @export
* @enum {string}
*/
export enum AuthTokenMetaExpiredReasonEnum {
    Expired = 'Expired',
    NewTokenGenerated = 'New Token Generated'
}


/**
 * Check if a given object implements the AuthTokenMeta interface.
 */
export function instanceOfAuthTokenMeta(value: object): value is AuthTokenMeta {
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('expiredReason' in value) || value['expiredReason'] === undefined) return false;
    if (!('usedAt' in value) || value['usedAt'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    return true;
}

export function AuthTokenMetaFromJSON(json: any): AuthTokenMeta {
    return AuthTokenMetaFromJSONTyped(json, false);
}

export function AuthTokenMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthTokenMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'state': json['state'],
        'type': json['type'],
        'expiresAt': (json['expiresAt'] == null ? null : new Date(json['expiresAt'])),
        'expiredReason': json['expiredReason'],
        'usedAt': (json['usedAt'] == null ? null : new Date(json['usedAt'])),
        'user': AuthTokenMetaUserFromJSON(json['user']),
    };
}

  export function AuthTokenMetaToJSON(json: any): AuthTokenMeta {
      return AuthTokenMetaToJSONTyped(json, false);
  }

  export function AuthTokenMetaToJSONTyped(value?: AuthTokenMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'state': value['state'],
        'type': value['type'],
        'expiresAt': (value['expiresAt'] == null ? null : (value['expiresAt'] as any).toISOString()),
        'expiredReason': value['expiredReason'],
        'usedAt': (value['usedAt'] == null ? null : (value['usedAt'] as any).toISOString()),
        'user': AuthTokenMetaUserToJSON(value['user']),
    };
}

